<template>
  <div v-if="!isMobile()">
    <div
      class="section section-partners"
      id="partners-section"
      data-background-color="white"
    >
      <div data-aos="fade-left" class="img_deco_02"></div>
      <div class="container text-center">
        <h3 class="title deco1">{{ $t(`Partners`) }}</h3>
        <div class="row" style="padding-top: 20px">
          <div
            class="box-investor text-center"
            v-for="(partner, index) in partners"
            v-bind:key="index"
          >
            <a v-bind:href="partner.url" target="_blank">
              <img
                v-bind:src="`/img/partners/${partner.img}`"
                width="100%"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="section-m section-partners"
      id="partners-section"
      data-background-color="black"
    >
      <div data-aos="fade-left" class="img_deco_02"></div>
      <div class="container text-center">
        <h3 class="title-m deco2">{{ $t(`Partners`) }}</h3>
        <div class="row" style="width: 85%; margin: auto;">
          <div
            class="box-partner-m text-center"
            v-for="(partner, index) in partners"
            v-bind:key="index"
          >
            <a v-bind:href="partner.url" target="_blank">
              <img
                v-bind:src="`/img/partners/${partner.img}`"
                height="100%"
                style="object-fit: contain; padding-top: 0px;"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data: function () {
    return {
      partners: [
        {
          url: "https://www.hashed.com/",
          width: "100%",
          height: "100%",
          style: {},
          img: "partner_01.png",
        },
        {
          url: "https://a16z.com/crypto/",
          width: "100%",
          height: "100%",
          style: {},
          img: "partner_02.png",
        },
        {
          url: "https://india.sequoiacap.com/",
          width: "100%",
          height: "100%",
          style: {},
          img: "partner_03.png",
        },
        {
          url: "https://labs.binance.com/",
          width: "100%",
          height: "100%",
          style: {},
          img: "partner_04.png",
        },
        {
          url: "https://www.blocktower.com/",
          width: "100%",
          height: "100%",
          style: {},
          img: "partner_05.png",
        },
        {
          url: "https://yieldguild.io/",
          width: "100%",
          height: "100%",
          style: {},
          img: "partner_06.png",
        },
        {
          url: "https://www.skyvisioncapital.com/",
          width: "100%",
          height: "100%",
          style: {},
          img: "partner_07.png",
        },
        {
          url: "https://despread.io/",
          width: "100%",
          height: "100%",
          style: {},
          img: "partner_08.png",
        },
        {
          url: "https://nodgames.com/",
          width: "100%",
          height: "100%",
          style: {"background-size": "contain"},
          img: "partner_09.png",
        },
        {
          url: "https://opensea.io/",
          width: "40%",
          height: "60%",
          style: {"background-size": "contain", "margin-top": "30px"},
          img: "partner_10.png",
        },
        {
          url: "https://www.sandbox.game/",
          width: "90%",
          height: "60px",
          style: { "margin-top": "35px" },
          img: "partner_11.png",
        },
        {
          url: "https://www.tokenpocket.pro/",
          width: "100%",
          height: "60px",
          style: {},
          img: "partner_12.png",
        },
        {
          url: "https://token.im/",
          width: "80%",
          height: "45px",
          style: { "margin-top": "45px" },
          img: "partner_13.png",
        },
        {
          url: "https://kyber.network/",
          width: "70%",
          height: "60px",
          style: { "margin-top": "25px" },
          img: "partner_22.png",
        },
        {
          url: "https://makerdao.com/",
          width: "100%",
          height: "60px",
          style: { "margin-top": "30px" },
          img: "partner_21.png",
        },
        {
          url: "https://trinito.co/",
          width: "80%",
          height: "55px",
          style: { "margin-top": "40px" },
          img: "partner_14.png",
        },
        // {
        //   url: "http://dappbirds.com/",
        //   width: "60%",
        //   style: { "margin-top": "20px" },
        //   img: "partner_08.png",
        // },
        // {
        //   url: "https://www.dappx.com/",
        //   width: "60%",
        //   style: { "margin-top": "20px" },
        //   img: "partner_09.png",
        // },
        // {
        //   url: "https://dapptotal.com/",
        //   width: "60%",
        //   style: { "margin-top": "30px" },
        //   img: "partner_10.png",
        // },
        // {
        //   url: "https://www.dapppocket.io/",
        //   width: "70%",
        //   style: { "margin-top": "20px" },
        //   img: "partner_11.png",
        // },
        // {
        //   url: "https://dappstats.com/",
        //   width: "60%",
        //   style: { "margin-top": "30px" },
        //   img: "partner_12.png",
        // },
        // {
        //   url: "https://www.topdapp.com/",
        //   width: "60%",
        //   style: { "margin-top": "20px" },
        //   img: "partner_13.png",
        // },
        // {
        //   url: "https://dapponline.io/",
        //   width: "60%",
        //   style: { "margin-top": "20px" },
        //   img: "partner_16.png",
        // },
        // {
        //   url: "https://planetariumhq.com/",
        //   width: "60%",
        //   style: { "margin-top": "25px" },
        //   img: "partner_17.png",
        // },
        // {
        //   url: "https://egamers.io/",
        //   width: "60%",
        //   style: { "margin-top": "25px" },
        //   img: "partner_18.png",
        // },
        // {
        //   url: "https://blocto.portto.io/",
        //   width: "60%",
        //   style: { "margin-top": "20px" },
        //   img: "partner_19.png",
        // },
        // {
        //   url: "https://despread.io/",
        //   width: "60%",
        //   style: { "margin-top": "20px" },
        //   img: "partner_20.png",
        // },
      ],
    };
  },
};
</script>
<style></style>
